import { LeagueInfoData } from "../LeagueInfoData";
export class LeagueInfo extends LeagueInfoData {
    constructor(leagueInfoData) {
        super(leagueInfoData);
    }
    checkCountryProps(league) {
        return this.CountryCode === league.CountryCode &&
            this.CountryTranslatedName === league.CountryTranslatedName &&
            this.isUserCountry === league.isUserCountry &&
            this.UrlCode === league.UrlCode;
    }
    compareByRankAndName(l1, l2) {
        if (l1.RankID > l2.RankID) {
            return 1;
        }
        if (l1.RankID < l2.RankID) {
            return -1;
        }
        if (l1.Name > l2.Name) {
            return 1;
        }
        if (l1.Name < l2.Name) {
            return -1;
        }
        return 0;
    }
    equals(league) {
        return this.ID === league.ID &&
            this.Name === league.Name &&
            this.RankID === league.RankID &&
            this.hasLiveStream === league.hasLiveStream &&
            this.MasterLeagueID === league.MasterLeagueID &&
            this.checkCountryProps(league);
    }
    compareTo(league) {
        return this.compareByRankAndName(this, league);
    }
    getFullName() {
        return `${this.Name} (${this.CountryTranslatedName})`;
    }
}
//# sourceMappingURL=LeagueInfo.js.map